module.exports = __webpack_public_path__ + "static/minixels-38ceb1216f9a8a9b47497672d174a846.jpg";